const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "supplierGoods":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "supplierGoods",
    reducer: reducer,
};

export default data;